import type { EntityProfileModule } from '../types';
import {
  fetchInvestorProfile,
  saveInvestorProfile,
  type InvestorProfileData,
} from '../api/investor-profile.api';
import { InvestorProfileSections } from './investor/InvestorProfileSections';

export const investorProfileModule: EntityProfileModule<InvestorProfileData> = {
  status: 'ready',
  queryKey: (entityId) => ['profile', 'investor', entityId],
  fetch: fetchInvestorProfile,
  save: saveInvestorProfile,
  Sections: InvestorProfileSections,
};
